module.exports = __webpack_public_path__ + "static/img/lohas-wx.12150f1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/website/lohas-wx.jpg
// module id = M7rC
// module chunks = 2